/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * Frontend JS.
 */
var $ = require("jquery");

/* --- Show schools on select BSO --- */

$(document).on('click', 'input[name=location-type]', function () {
    // console.log($(this).is('#type-dark'));
    if($(this).is('#type-dark') && $(this).prop('checked')) {
        $('.block-search-location .schools').show();
    } else {
        $('.block-search-location .schools').hide();
    }
});
if($('input#type-dark').prop('checked')) {
    $('.block-search-location .schools').show();
} else {
    $('.block-search-location .schools').hide();
}

/* --- Submit frontpage location form --- */

if( $( 'body.home' ).length > 0 ) {
    $(document).on('click', '.block-search-location .wp-block-button__link', function () {
        $( '.block-search-location form' ).submit();
    });
}